export const getUAParams = (ua: string, key?: string) => {
  const uaObj = {}
  ua.split(' ')?.forEach((v) => {
    const [keyName, value] = v.split('/')
    if (keyName && value) {
      uaObj[keyName] = value
    }
  })

  if (key) {
    return uaObj[key]
  }
  return uaObj
}

const getUa = () => window?.navigator.userAgent

export const isInApp = (ua?: string) => /PiPi|xyllive/i.test(ua || getUa())

export const isPP = (ua?: string) => /(PiPi|xyllive)/i.test(ua || getUa())
export const isZY = (ua?: string) => /(Zuiyou)/i.test(ua || getUa())
export const isWanxiang = (ua?: string) => /(wanxiang)/i.test(ua || getUa())

export const isMobile = (ua?: string) =>
  /(iphone|ipad|ipod|android)/i.test(ua || getUa())

export const isAndroid = (ua?: string) => /android|linux/i.test(ua || getUa())

export const isIOS = (ua?: string) => /(iphone|ipad|ipod)/i.test(ua || getUa())

export const isWX = (ua?: string) => /micromessenger/i.test(ua || getUa())

export const isQQ = (ua?: string) => /qq\//i.test(ua || getUa())

export const isWB = (ua?: string) => /weibo/i.test(ua || getUa())

export const isXiaoHongShu = (ua: string) => /xiaohongshu|xhs/i.test(ua)
